@if (facade.error()) {
<div class="error-container h-100">
    <div class="error-content">
        <mat-icon>error</mat-icon>
        <h2>{{ 'shared.api.errors.default' | translate }}</h2>
    </div>
</div>
}
@else {
<div class="dashboard-container container px-2 pb-2 gap-2 h-100">
    <div class="filter-container">
        <label class="search-label">{{ 'shared.general.labels.quick_search' | translate }}</label>
        <mat-form-field appearance="outline">
            <mat-label>{{ 'app.users.dashboard.search_label' | translate }}</mat-label>
            <input matInput [placeholder]="'app.users.dashboard.search_placeholder' | translate"
                [formControl]="searchControl">
            @if (searchControl.value) {
            <button mat-icon-button matSuffix class="me-2" (click)="searchControl.reset()">
                <mat-icon>close</mat-icon>
            </button>
            } @else {
            <mat-icon matSuffix class="icon-md">search</mat-icon>
            }
            <mat-hint>{{ 'app.users.dashboard.search_hint' | translate }}</mat-hint>
        </mat-form-field>
    </div>
    <div class="table-container">
        <app-all-users-table></app-all-users-table>
    </div>
</div>
}